import PropTypes from 'prop-types';
import { Checkbox, Tooltip } from '@mui/material';
import { useScopeCheck } from '../../../../../reusable-components/scopes';
import { useDispatch, useSelector } from '../../../../../redux/store';
import { updateUsersRolesInRedux } from '../../../../../redux/slices/users';
import {
  TRANSPORT_ADMIN,
  TRANSPORT_COORDINATOR,
  TRANSPORT_NURSE,
  TRANSPORT_VIEW_ONLY,
} from '../../../transports/constants';

RolesCheckbox.propTypes = {
  role: PropTypes.string,
};
const roleDependencies = {
  'Invoice-Edit': ['Invoice-View'],
  'ManualInvoice-Edit': ['ManualInvoice-View'],
};

const transportExclusiveRoles = new Set([TRANSPORT_ADMIN, TRANSPORT_COORDINATOR, TRANSPORT_NURSE, TRANSPORT_VIEW_ONLY]);

export default function RolesCheckbox({ role }) {
  const dispatch = useDispatch();
  const {
    data: { user },
  } = useSelector((state) => state.users);
  const { roles } = user;

  const hasEditAccess = useScopeCheck(['User-Edit'], true);
  const hasRole = roles.some((item) => item === role);

  const editRole = Object.keys(roleDependencies).find((key) => roleDependencies[key].includes(role));
  const disableViewRole = editRole ? roles.includes(editRole) && hasRole : false;

  const isTransportExclusiveRole = transportExclusiveRoles.has(role);
  const activeTransportRole = roles.find((item) => transportExclusiveRoles.has(item));
  const disableTransportExclusiveRole =
    isTransportExclusiveRole && !hasRole && activeTransportRole && activeTransportRole !== role;

  const disableReason = disableViewRole
    ? 'The view role cannot be deactivated while edit role is active.'
    : disableTransportExclusiveRole
    ? `This ${role} role cannot be made active while ${activeTransportRole} role is active.`
    : '';

  const handleSwitchActiveRole = (e) => {
    e.stopPropagation();
    if (hasRole) {
      dispatch(updateUsersRolesInRedux(roles.filter((item) => item !== role)));
    } else {
      const newRoles = [role, ...(roleDependencies[role] || [])];
      dispatch(updateUsersRolesInRedux([...roles, ...newRoles]));
    }
  };

  return (
    <>
      <Tooltip title={disableReason}>
        <span>
          <Checkbox
            checked={hasRole}
            onChange={handleSwitchActiveRole}
            disabled={!hasEditAccess || disableViewRole || disableTransportExclusiveRole}
          />
        </span>
      </Tooltip>
    </>
  );
}
